module.exports = __webpack_public_path__ + "static/media/fly0230.1527e8eb.webp";